import BigNumber from 'bignumber.js';
import { Address } from 'viem';

import { api, cacheTags } from 'modules/api';
import { MAIN_TOKEN_ADDRESS } from 'modules/api/const';
import { getPublicClient } from 'modules/api/getPublicClient';
import { handleSafeAppTransaction } from 'modules/api/methods/handleSafeAppTransaction';
import { setAllowance } from 'modules/api/methods/setAllowance';
import { asAddress } from 'modules/api/utils/asAddress';
import { getWalletClient } from 'modules/api/walletClient';
import { queryFnNotifyWrapper } from 'modules/common/utils/queryFnNotifyWrapper';

interface ISetAllowanceArgs {
  poolAddress: Address;
  amount: BigNumber;
}

export const { useSetAllowanceMutation } = api.injectEndpoints({
  endpoints: build => ({
    setAllowance: build.mutation<boolean, ISetAllowanceArgs>({
      queryFn: queryFnNotifyWrapper<ISetAllowanceArgs, void, boolean>(
        async ({ amount, poolAddress }, { dispatch }) => {
          const walletClient = getWalletClient();
          const publicClient = getPublicClient();

          const txPromise = setAllowance(walletClient, {
            spender: asAddress(poolAddress),
            tokenAddress: MAIN_TOKEN_ADDRESS,
            amount,
          });

          await handleSafeAppTransaction({
            txPromise,
            dispatch,
            publicClient,
            accountAddress: asAddress(walletClient.account?.address),
          });

          return {
            data: true,
          };
        },
      ),
      invalidatesTags: [cacheTags.allowance],
    }),
  }),
});
